/**
 * mwApp.parters module <br>
 * Work with Parters - distributors, etc
 *
 * @namespace mwApp/partners
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc config
 * @name mwApp/partners.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /distributors
     */
    .state('app.distributors', {
      abstract: true,
      url: '/distributors',
      template: '<ui-view/>',
      resolve: {
        scope: ['$state', 'authSvc', function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('FEATURE_DISTRIBUTORS_ENABLED')) {
            return $state.go('app.404')
          }
          // use object 'scope' to share object between different views
          return {
            featureEnabled: true
          }
        }]
      }
    })

    /**
     * controller {@link mwApp/partners.controller:DistributorsCtrl}
     * @name /distributors
     * @memberof mwApp/partners.config:ConfigRoutes
     */
    .state('app.distributors.list', {
      url: '',
      templateUrl: 'components/partners/views/distributors.html',
      controller: 'DistributorsCtrl as vm',
      label: 'Distributors',
      access: 'viewDistributor'
    })

    /**
     * abstract state for /distributors/:distributorId
     */
    .state('app.distributors.distributor', {
      abstract: true,
      url: '/:distributorId',
      template: '<ui-view/>',
      resolve: {
        distributor: /* @ngInject */ function ($transition$, Distributor) {
          var { distributorId: id } = $transition$.params()
          return +id
            ? Distributor.load({ id })
            : new Distributor()
        }
      }
    })

    /**
     * controller {@link mwApp/partners.controller:AddDistributorCtrl}
     * @name /distributors/:distributorId
     * @memberof mwApp/partners.config:ConfigRoutes
     */
    .state('app.distributors.distributor.edit', {
      url: '',
      templateUrl: 'components/partners/views/addDistributor.html',
      controller: 'AddDistributorCtrl as vm',
      label: '{{::distributorId | addOrEdit}} Distributor',
      access: ':distributorId (+) ! IF createDistributor ELSE editDistributor'
    })

    /**
     * controller {@link mwApp/partners.controller:VoucherBatchesCtrl}
     * @name /distributors/:distributorId/batches
     * @memberof mwApp/partners.config:ConfigRoutes
     */
    .state('app.distributors.distributor.batches', {
      url: '/batches',
      templateUrl: 'components/partners/views/voucherBatches.html',
      controller: 'VoucherBatchesCtrl as vm',
      label: 'Batches',
      access: 'viewVoucherBatch'
    })
}
